import React, {FC, ReactNode} from 'react';
import styled from 'styled-components';

import {fontSizes} from '../../../../libs/shared/ui/src/styles/fontStyles';
import {ellipsis} from '../../../../libs/shared/ui/src/styles/mixins';

/*
 * Props.
 */

interface DropdownItemMultilineProps {
  title: ReactNode;
  subtitle?: ReactNode;
}

/*
 * Style.
 */

const StyledContentDiv = styled.div`
  grid-area: content;

  display: flex;
  flex-direction: column;
  min-width: 0;
  max-width: 100%;
  margin-left: 4px;
`;

const StyledTitleDiv = styled.div`
  margin-top: 2px;
  height: 21px;
  color: ${(p) => p.theme.greys.shade80};
  font-size: ${fontSizes.medium};
  ${ellipsis()};
`;

const StyledSubtitleDiv = styled.div`
  height: 15px;
  color: ${(p) => p.theme.greys.shade70};
  font-size: ${fontSizes.verySmall};
  ${ellipsis()};
`;

/*
 * Component.
 */

export const DropdownItemMultiline: FC<DropdownItemMultilineProps> = (props) => (
  <StyledContentDiv>
    <StyledTitleDiv>{props.title}</StyledTitleDiv>
    {props.subtitle && <StyledSubtitleDiv>{props.subtitle}</StyledSubtitleDiv>}
  </StyledContentDiv>
);
